import { useEffect, useRef } from 'react'
import { onBridgeEvent } from './bridge'
import type { BridgeEvent, BridgeEvents } from './types'

export function useBridgeEvent<E extends BridgeEvent>(
  event: E,
  handler: (payload: BridgeEvents[E]) => void,
) {
  const ref = useRef(handler)
  useEffect(() => {
    ref.current = handler
  })
  useEffect(() => onBridgeEvent(event, (p) => ref.current(p)), [event])
}
